import { render, staticRenderFns } from "./TodoRejectConfirmDialog.vue?vue&type=template&id=f6c152da&scoped=true&"
import script from "./TodoRejectConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./TodoRejectConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./TodoRejectConfirmDialog.vue?vue&type=style&index=0&id=f6c152da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c152da",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TodoListTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Ftodo-list%2FTodoRejectConfirmDialog.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports